<template>
    <div class="backgroud-white cs-homework-files" v-if="files.length>0">
        <el-row class="cs-homework-files-header">
            <span class="cs-homework-title">文件</span>
        </el-row>
        <div>
            <ul>
                <li v-for="file in files" :key="file.Id">
                    <el-row>
                        <el-col :span="18" class="cs-homework-filename">{{file.FileName}}</el-col>
                        <el-col :span="6">
                            <el-button :loading="file.isLoading" type="primary" size="mini" @click="download(file.Url,file.FileName, file)">下载</el-button>
                        </el-col>
                    </el-row>
                </li>
            </ul>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-homework-files {
    padding: 10px 30px;
    ul {
        margin: 0;
        padding: 0
    }
    ul>li {
        list-style-type: none;
        color: #006ab4;
        padding-top: 0.5rem;
    }

    .cs-homework-files-header {
        margin-bottom: 1rem;
    }
    .cs-homework-file-title {
        font-weight: bold;
        font-size: 20px;
        padding-right: 10px;
        text-align: right;
    }
    .cs-homework-filename{
        overflow: hidden;
    }
}
</style>

<script>
import {
  getCourseHomeworkFileList
} from "../../service/homework.service";
import {
  downloadFileWithName
} from "@/service/blobStorage.service";


export default {
    props: {
        data: {
            homeworkId: Number
        },
    },
    data() {
        return {
            isLoading: false,
            files: []
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            this.loadFileList();
        },
        loadFileList(){
            if (!this.data.homeworkId){
                return;
            }
            this.isLoading = true;
            getCourseHomeworkFileList(this.data.homeworkId).then(result =>{
                if (!!result && result.success){
                    let list = result.data;
                    list.forEach(element => {
                        element.isLoading = false;
                    });
                    this.files = result.data;
                }else{
                    if (!!result.message){
                        this.$message.error(result.message);
                    }
                }
                this.isLoading = false;
            }).catch(()=>{
                this.isLoading = false;
            });
        },
        download(url, fileName, file) {   
            file.isLoading = true;
            downloadFileWithName(url, fileName)
                .then((result) => {
                    file.isLoading = false;
                })
                .catch(() => {
                    setTimeout(() => {
                        console.log("download from url", url);
                        window.open(url, "_blank");
                    });
                    file.isLoading = false;
                });
            // var link = document.createElement("a");
            // link.target="_blank";
            // link.href = url;
            // link.download = fileName;
            // link.click();
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/homeworkFiles.vue